import React, { useRef, useState, useEffect } from 'react';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';
import { PIZZAS } from '../constants';
import BounceCards from './BounceCards';

const MenuGrid: React.FC = () => {
  const container = useRef<HTMLDivElement>(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const images = PIZZAS.map(p => p.image);

  // Responsive "Gravity-Defying" transform styles bounded inside screen edges
  const transformStyles = isMobile 
    ? [
        "rotate(8deg) translate(-75px, 15px)",
        "rotate(-5deg) translate(-45px, -8px)",
        "rotate(3deg) translate(-15px, 5px)",
        "rotate(-4deg) translate(15px, -10px)",
        "rotate(6deg) translate(45px, 8px)",
        "rotate(-8deg) translate(75px, -5px)"
      ]
    : [
        "rotate(12deg) translate(-280px, 30px)",
        "rotate(-8deg) translate(-160px, -15px)",
        "rotate(4deg) translate(-40px, 10px)",
        "rotate(-6deg) translate(70px, -20px)",
        "rotate(10deg) translate(190px, 15px)",
        "rotate(-12deg) translate(300px, -10px)"
      ];

  useGSAP(() => {
    gsap.from(".section-header", {
      scrollTrigger: {
        trigger: container.current,
        start: "top 80%",
      },
      y: 40,
      opacity: 0,
      duration: 1,
      ease: "power3.out"
    });
  }, { scope: container });

  return (
    <div ref={container} className="py-20 md:py-32 px-6 md:px-12 bg-[#F2E9D8] overflow-hidden">
      <div className="max-w-7xl mx-auto space-y-12 md:space-y-20">
        <div className="section-header flex flex-col md:flex-row justify-between items-start md:items-end gap-8 border-b border-[#1A3C28]/10 pb-8">
          <div>
            <h2 className="font-display text-5xl sm:text-6xl md:text-8xl font-black uppercase tracking-tighter text-[#1A3C28] leading-[0.85]">
              Local <span className="text-[#E05A38]">Icons</span>
            </h2>
            <p className="max-w-md font-bold uppercase text-[10px] md:text-xs tracking-widest text-[#1A3C28]/60 mt-4 leading-relaxed">
              Every pie is hand-stretched in our wood-fired oven using locally-sourced ingredients and 72-hour fermented sourdough.
            </p>
          </div>
        </div>

        {/* Dynamic BounceCards Visual Stack */}
        <div className="flex justify-center items-center py-6 md:py-10">
          <BounceCards
            images={images}
            containerWidth="100%"
            containerHeight={isMobile ? 380 : 460}
            animationDelay={0.1}
            animationStagger={0.08}
            easeType="elastic.out(1, 0.7)"
            transformStyles={transformStyles}
            enableHover={true}
          />
        </div>
      </div>
    </div>
  );
};

export default MenuGrid;
